import React, { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form, FormControl, Spinner } from "react-bootstrap";
import IconSearch from '../../../../styles/images/search-icon-small.png';
import IconClose from '../../../../styles/images/close.png';
import { handleChangeDataSearchBranchAutoComplete } from '../../../../redux/actions/partials/search/searchBranch';
import axios from "axios";
import * as qs from "querystring";
import { BASE_SITE, SHOP_SEARCH_BRANCH_POST } from '../../../../apis'; 
import CardShopBranch from './cardShopBranch';


const Search = (props) => {

    const dispatch = useDispatch();

    const { text, isLoading, result } = useSelector(state => state.searchBranch);

    const focusBox = React.createRef();
    const cancelSearch = useRef(null);

    const handleSubmitFormSearch = () => {

    };

    const handleChangeInputSearch = (event) => {
        const {value} = event.target;

        dispatch(handleChangeDataSearchBranchAutoComplete('text', value));


        if (value.length >= 2) {
            callApiSearch(value);
        }
    };

    const handleOnFocusSearch = (event) => {
        const FOCUS_BOX = focusBox.current;
        FOCUS_BOX.setAttribute("class", "box-search d-flex align-items-center pl-3 mb-3 custom-focus");
        handleChangeInputSearch(event);
    };

    const handleOnBlurSearch = () => {
        const FOCUS_BOX = focusBox.current;
        FOCUS_BOX.setAttribute("class", "box-search d-flex align-items-center pl-3 mb-3");

    };

    const removeTextSearch = () => {
        dispatch(handleChangeDataSearchBranchAutoComplete('text', ''));
        dispatch(handleChangeDataSearchBranchAutoComplete('result', []));
    };


    const callApiSearch = async (value) => {
        try {
            dispatch(handleChangeDataSearchBranchAutoComplete('isLoading', true));

            if (cancelSearch.current) {
                cancelSearch.current('search canceled');
            }

            const response = await axios.post(BASE_SITE + SHOP_SEARCH_BRANCH_POST,
                qs.stringify({
                    search_text: value,
                    installments: '1'
                }), {
                    cancelToken: new axios.CancelToken(cancel => cancelSearch.current = cancel)
                });


            const {data} = response;

            if (data.status === 'ok') {
                dispatch(handleChangeDataSearchBranchAutoComplete('result', data.shops));
            } else {
                // LIST_SEARCH.setAttribute("class", "list-auto-autocomplete hide");
            }
            if (data)
                dispatch(handleChangeDataSearchBranchAutoComplete('isLoading', false));

        } catch (e) {
            console.log(e);
        }
    }

    return (
        <>
        <Form onSubmit={handleSubmitFormSearch} className={'w-100 mt-3'}>
            <div className="box-search d-flex align-items-center pl-3 mb-4" ref={focusBox}>
                <FormControl id=""
                                className={'input-search no-border h-100 px-0'}
                                onChange={handleChangeInputSearch} autoComplete={"off"}
                                onFocus={handleOnFocusSearch}
                                onBlur={handleOnBlurSearch}
                                value={text}
                                placeholder="جستجو"/>
                <div className="d-flex pr-3 h-100">
                    <div className="d-flex align-items-center mx-3">
                        { 
                            isLoading ? 
                                <Spinner className='spinner-input-search spinner-grow-sm' animation={"grow"}  />
                            : 
                                (text.length > 0 ? <img src={IconClose} className="spinner-input-search" alt="remove" onClick={removeTextSearch} /> : null)
                        }
                    </div>
                    
                    <div className="d-flex align-items-center">
                        <img src={IconSearch} width={23} alt="search" />
                    </div>
                </div>
                    
            </div>

            {
                result.map((item, key) => {
                    return(
                        <CardShopBranch data={{item}} type={props.type} key={key} />
                    );
                })
            }

        </Form>
        </>
    );
}

export default Search;